<template>
<div class="chapter">
<div class="inner_page">
<p class="fm-head">CONTENTS</p>
<p class="toc"><a href="#/Acknowledgements">Acknowledgements</a></p>
<p class="toc"><a href="#/Foreword">Foreword, by Chuck Kyle</a></p>
<p class="toc"><a href="#/Introduction">Introduction, by Mike Trivisonno</a></p>
<p class="toc1"><a href="#/Chapter1#C1">1. The Game: Massillon vs. Canton McKinley</a></p>
<p class="toc"><span href="#/Chapter2#C2" title="Link target outside of Sample">2. The Holy War: St. Ignatius vs. St. Edward</span></p>
<p class="toc"><span href="#/Chapter3#C3" title="Link target outside of Sample">3. The Silver Rail: Avon vs. Avon Lake</span></p>
<p class="toc"><span href="#/Chapter4#C4" title="Link target outside of Sample">4. Instant Classics: Massillon vs. Hoban</span></p>
<p class="toc"><span href="#/Chapter5#C5" title="Link target outside of Sample">5. The Bagley Cup: Olmsted Falls vs. Berea-Midpark</span></p>
<p class="toc"><span href="#/Chapter6#C6" title="Link target outside of Sample">6. State-Bound Drama: Hoban vs. Avon</span></p>
<p class="toc"><span href="#/Chapter7#C7" title="Link target outside of Sample">7. Crosstown Rivals: Rocky River vs. Bay Village</span></p>
<p class="toc"><span href="#/Chapter8#C8" title="Link target outside of Sample">8. <i>Friday Night Touchdown</i></span></p>
<p class="toc1"><span href="#/Epilogue" title="Link target outside of Sample">Epilogue</span></p>
<p class="toc"><span href="#/Appendix" title="Link target outside of Sample">Appendix: Football Best-of Lists</span></p>
<p class="toc"><span href="#/Author" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?e3f74dee